// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingDetails-Payment-styles___paper--y04EA {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

h2 {
  text-align: left;
}

.components-BookingDetails-Payment-styles___payment--ZXVut {
  text-align: left;
  padding: 32px;
  margin-bottom: 32px;
}

.components-BookingDetails-Payment-styles___payment--ZXVut .components-BookingDetails-Payment-styles___header--A_dZx {
    font-size: 17px;
    line-height: 20px;
    font-weight: 500;
  }

.components-BookingDetails-Payment-styles___payment--ZXVut .components-BookingDetails-Payment-styles___inputContainer--usGEL {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px 0 32px 0;
    border-bottom: 1px solid #c6c8cc;
  }

.components-BookingDetails-Payment-styles___payment--ZXVut .components-BookingDetails-Payment-styles___inputWrapper--LVCol {
    flex: 49% 0 1;
    padding: 8px 0 0;
  }

.components-BookingDetails-Payment-styles___payment--ZXVut .components-BookingDetails-Payment-styles___actions--SE5sb {
    padding: 32px 0 0;
    display: flex;
    justify-content: flex-end;
  }

.components-BookingDetails-Payment-styles___payment--ZXVut .components-BookingDetails-Payment-styles___button--nJm_l {
    text-transform: initial;
    min-width: 100px;
  }

.components-BookingDetails-Payment-styles___MuiTab--tTF5t .components-BookingDetails-Payment-styles___selected--iRJuH {
  color: blue !important;
}

.components-BookingDetails-Payment-styles___inputContainer--usGEL {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-BookingDetails-Payment-styles___inputContainer--usGEL.components-BookingDetails-Payment-styles___passportInfo--U4Q1V {
    padding-bottom: 24px;
  }

.components-BookingDetails-Payment-styles___inputWrapper--LVCol {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-BookingDetails-Payment-styles___actions--SE5sb {
  padding: 32px 0 0;
  display: flex;
  justify-content: flex-end;
}

.components-BookingDetails-Payment-styles___button--nJm_l {
  text-transform: initial;
  min-width: 100px;
}

.components-BookingDetails-Payment-styles___tabs--SxUEo,
.components-BookingDetails-Payment-styles___tab--xVOcd {
  text-transform: initial !important;
}

.components-BookingDetails-Payment-styles___tabs--SxUEo,
.components-BookingDetails-Payment-styles___tab--xVOcd .components-BookingDetails-Payment-styles___selected--iRJuH {
  color: red !important;
}

.components-BookingDetails-Payment-styles___tabs--SxUEo {
  border-bottom: 1px solid #c6c8cc;
}

.components-BookingDetails-Payment-styles___loyalityTabs--TTli1 {
  margin-top: 16px;
}

.components-BookingDetails-Payment-styles___loyalityTabs--TTli1 .components-BookingDetails-Payment-styles___tab--xVOcd {
    flex: 1;
    max-width: 100% !important;
  }

.components-BookingDetails-Payment-styles___paper--y04EA {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-BookingDetails-Payment-styles___dropdown--_0avS {
  padding: 15px;
  max-width: 736px;
}

.components-BookingDetails-Payment-styles___root--QKjy6 {
  width: 100%;
}

.components-BookingDetails-Payment-styles___menuItem--ZupkK {
  font-size: 15px;
  color: #1b2432 !important;
  line-height: 18px;
}

.components-BookingDetails-Payment-styles___listItem--mjMmF {
  height: auto !important;
  padding-top: 8px;
  padding-bottom: 8px;
}

.components-BookingDetails-Payment-styles___location--uk86M {
  margin-bottom: 5px;
}

.components-BookingDetails-Payment-styles___inputContainer--usGEL {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-BookingDetails-Payment-styles___inputContainer--usGEL.components-BookingDetails-Payment-styles___passportInfo--U4Q1V {
    padding-bottom: 24px;
  }

.components-BookingDetails-Payment-styles___inputWrapper--LVCol {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-BookingDetails-Payment-styles___inputInVisible--OkmmX {
  display: none;
}

.components-BookingDetails-Payment-styles___inputWrapper_department--ld4D5 {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-BookingDetails-Payment-styles___inputWrapper_department--ld4D5 div label {
    z-index: 0;
  }

.components-BookingDetails-Payment-styles___table--nLDAN {
  margin: 20px 0 0;
}

.components-BookingDetails-Payment-styles___tableHead--drqlB {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-BookingDetails-Payment-styles___tableRow--QJE4J {
  height: 68px !important;
}

.components-BookingDetails-Payment-styles___tableRow--QJE4J:last-child .components-BookingDetails-Payment-styles___tableCell--RCsrP {
      border: none;
    }

.components-BookingDetails-Payment-styles___tableRow--QJE4J.components-BookingDetails-Payment-styles___addNewTableRow--qQC__ {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

.components-BookingDetails-Payment-styles___tableCell--RCsrP {
  font-size: 15px !important;
  padding: 16px 30px 16px 24px !important;
}

.components-BookingDetails-Payment-styles___tableCell--RCsrP.components-BookingDetails-Payment-styles___removeCell--nGP08 {
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }

.components-BookingDetails-Payment-styles___tableCell--RCsrP.components-BookingDetails-Payment-styles___removeCell--nGP08 button {
      padding-left: 0;
      padding-right: 0;
    }

.components-BookingDetails-Payment-styles___tableCell--RCsrP.components-BookingDetails-Payment-styles___inputTableCell--SAltp {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-BookingDetails-Payment-styles___tableCell--RCsrP.components-BookingDetails-Payment-styles___inputTableCell--SAltp > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-BookingDetails-Payment-styles___tableCell--RCsrP.components-BookingDetails-Payment-styles___buttonTableCell--VMpux {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-BookingDetails-Payment-styles___emptyData--mFr5r {
  padding: 24px 0;
}

.components-BookingDetails-Payment-styles___selectWrapper--enCgC {
  width: 100%;
}

.components-BookingDetails-Payment-styles___phoneFields--DyCFZ {
  display: flex;
}

.components-BookingDetails-Payment-styles___phoneFields--DyCFZ .components-BookingDetails-Payment-styles___countryCode--mPmia {
    margin-right: 6px;
  }

.components-BookingDetails-Payment-styles___buttons--RAIEx {
  border-top: 1px solid #dddee0;
  padding-top: 32px;
  display: flex;
  justify-content: flex-end;
}

.components-BookingDetails-Payment-styles___cancel--in4DH {
  color: #6d717a;
  margin-right: 12px;
}

.components-BookingDetails-Payment-styles___tabs--SxUEo,
.components-BookingDetails-Payment-styles___tab--xVOcd {
  text-transform: initial !important;
}

.components-BookingDetails-Payment-styles___tabs--SxUEo {
  border-bottom: 1px solid #c6c8cc;
}

.components-BookingDetails-Payment-styles___loyalityTabs--TTli1 {
  margin-top: 16px;
}

.components-BookingDetails-Payment-styles___loyalityTabs--TTli1 .components-BookingDetails-Payment-styles___tab--xVOcd {
    flex: 1;
    max-width: 100% !important;
  }

.components-BookingDetails-Payment-styles___addProgram--N2jxW {
  display: flex;
  align-items: center;
  color: #1e8aff !important;
  font-size: 13px;
  padding: 18px 0 18px 24px;
  border-bottom: 1px solid #c6c8cc;
  cursor: pointer;
}

.components-BookingDetails-Payment-styles___addProgram--N2jxW:hover {
    color: #f6f6f7;
  }

.components-BookingDetails-Payment-styles___addProgram--N2jxW {
  width: 100%;
  font-weight: 500;
}

.components-BookingDetails-Payment-styles___addIcon--FDipl {
  height: 18px;
  margin-right: 5px;
}

.components-BookingDetails-Payment-styles___close--dEJH5 {
  cursor: pointer;
}

.components-BookingDetails-Payment-styles___close--dEJH5 .components-BookingDetails-Payment-styles___icon--Jn7hu {
    color: rgba(0, 0, 0, 0.23);
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG {
  text-align: left;
  padding: 32px;
  margin-bottom: 32px;
}

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___header--A_dZx {
    display: flex;
    padding: 0 0 24px;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___header--A_dZx .components-BookingDetails-Payment-styles___avatar--t0Kyf {
      margin-right: 24px;
    }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___header--A_dZx .components-BookingDetails-Payment-styles___title--Oo7og {
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      color: #1b2432;
      letter-spacing: 0;
    }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___header--A_dZx .components-BookingDetails-Payment-styles___title--Oo7og span {
        font-size: 13px;
        color: #6d717a;
        line-height: 15px;
        font-weight: 400;
      }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___infoHeader--sRrX1 {
    display: flex;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___infoHeader--sRrX1 .components-BookingDetails-Payment-styles___avatar--t0Kyf {
      margin-right: 24px;
      margin-top: 3px;
    }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___infoHeader--sRrX1 .components-BookingDetails-Payment-styles___title--Oo7og {
      font-weight: 500;
      font-size: 17px;
      line-height: 20px;
      color: #1b2432;
      letter-spacing: 0;
      flex: 1;
      display: flex;
      align-items: flex-end;
    }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___infoHeader--sRrX1 .components-BookingDetails-Payment-styles___title--Oo7og svg {
        margin-left: 32px;
      }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___infoHeader--sRrX1 .components-BookingDetails-Payment-styles___title--Oo7og span {
        font-size: 13px;
        color: #6d717a;
        line-height: 15px;
        font-weight: 400;
      }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___infoHeader--sRrX1 .components-BookingDetails-Payment-styles___button--nJm_l {
      color: #318afb;
      border: 1px solid #318afb;
      max-width: 74px;
      min-width: 74px;
      height: 32px;
    }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___tabs--SxUEo,
  .components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___tab--xVOcd {
    text-transform: initial !important;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___tabs--SxUEo {
    border-bottom: 1px solid #c6c8cc;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___inputContainer--usGEL {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 16px 0 32px 0;
    border-bottom: 1px solid #c6c8cc;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___inputWrapper--LVCol {
    flex: 49% 0 1;
    padding: 8px 0 0;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___optional--IG1KE {
    font-size: 11px;
    color: #6d717a;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___actions--SE5sb {
    padding: 32px 0 0;
    display: flex;
    justify-content: flex-end;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___button--nJm_l {
    text-transform: initial;
    min-width: 100px;
    margin-left: 10px;
  }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___button--nJm_l.components-BookingDetails-Payment-styles___buttonCancel--GLUxz {
      color: #6d717a;
    }

.components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___button--nJm_l.components-BookingDetails-Payment-styles___buttonCancel--GLUxz:hover,
      .components-BookingDetails-Payment-styles___paymentInfo--eWxPG .components-BookingDetails-Payment-styles___button--nJm_l.components-BookingDetails-Payment-styles___buttonCancel--GLUxz:focus {
        background: transparent;
      }

.components-BookingDetails-Payment-styles___loaderContainer--sBS9d {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.components-BookingDetails-Payment-styles___dot--kjMbe {
  height: 4px;
  width: 4px;
  background-color: #6d717a;
  border-radius: 50%;
  display: inline-block;
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./components/BookingDetails/Payment/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AA+BrB;;AA7BE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;AAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;EAClC;;AAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;AAEA;IACE,iBAAiB;IACjB,aAAa;IACb,yBAAyB;EAC3B;;AAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;AAEF;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AAKtB;;AAHE;IACE,oBAAoB;EACtB;;AAGF;EACE,aAAa;EACb,gBAAgB;AAClB;;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AACA;;EAEE,kCAAkC;AACpC;;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAMlB;;AAJE;IACE,OAAO;IACP,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AAKtB;;AAHE;IACE,oBAAoB;EACtB;;AAGF;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AACA;EACE,aAAa;EACb,gBAAgB;AAKlB;;AAHE;IACE,UAAU;EACZ;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AAWzB;;AARI;MACE,YAAY;IACd;;AAGF;IACE,+CAA+C;EACjD;;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;AA4BzC;;AA1BE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EAMd;;AAJE;MACE,eAAe;MACf,gBAAgB;IAClB;;AAGF;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AAKf;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAMlB;;AAJE;IACE,OAAO;IACP,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AAMjB;;AALE;IACE,cAAc;EAChB;;AC1QF;ED2QE,WAAW;EACX;CC5QF;;AD+QA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AAKjB;;AAHE;IACE,0BAA0B;EAC5B;;AAGF;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AAgHrB;;AA9GE;IACE,aAAa;IACb,iBAAiB;EAoBnB;;AAlBE;MACE,kBAAkB;IACpB;;AAEA;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,iBAAiB;IAQnB;;AANE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;MAClB;;AAIJ;IACE,aAAa;EAoCf;;AAlCE;MACE,kBAAkB;MAClB,eAAe;IACjB;;AAEA;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,iBAAiB;MACjB,OAAO;MACP,aAAa;MACb,qBAAqB;IAYvB;;AAVE;QACE,iBAAiB;MACnB;;AAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;MAClB;;AAGF;MACE,cAAc;MACd,yBAAyB;MACzB,eAAe;MACf,eAAe;MACf,YAAY;IACd;;AAGF;;IAEE,kCAAkC;EACpC;;AAEA;IACE,gCAAgC;EAClC;;AAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;EAClC;;AAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;AAEA;IACE,eAAe;IACf,cAAc;EAChB;;AAEA;IACE,iBAAiB;IACjB,aAAa;IACb,yBAAyB;EAC3B;;AAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;EAUnB;;AARE;MACE,cAAc;IAMhB;;AAJE;;QAEE,uBAAuB;MACzB;;AAIN;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\nh2 {\n  text-align: left;\n}\n.payment {\n  text-align: left;\n  padding: 32px;\n  margin-bottom: 32px;\n\n  .header {\n    font-size: 17px;\n    line-height: 20px;\n    font-weight: 500;\n  }\n\n  .inputContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding: 16px 0 32px 0;\n    border-bottom: 1px solid #c6c8cc;\n  }\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 8px 0 0;\n  }\n\n  .actions {\n    padding: 32px 0 0;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .button {\n    text-transform: initial;\n    min-width: 100px;\n  }\n}\n.MuiTab .selected {\n  color: blue !important;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n\n  &.passportInfo {\n    padding-bottom: 24px;\n  }\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n.actions {\n  padding: 32px 0 0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button {\n  text-transform: initial;\n  min-width: 100px;\n}\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n.tabs,\n.tab .selected {\n  color: red !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n}\n\n.loyalityTabs {\n  margin-top: 16px;\n\n  .tab {\n    flex: 1;\n    max-width: 100% !important;\n  }\n}\n\n.paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.dropdown {\n  padding: 15px;\n  max-width: 736px;\n}\n\n.root {\n  width: 100%;\n}\n\n.menuItem {\n  font-size: 15px;\n  color: #1b2432 !important;\n  line-height: 18px;\n}\n\n.listItem {\n  height: auto !important;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.location {\n  margin-bottom: 5px;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n\n  &.passportInfo {\n    padding-bottom: 24px;\n  }\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.inputInVisible {\n  display: none;\n}\n.inputWrapper_department {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n\n  div label {\n    z-index: 0;\n  }\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 30px 16px 24px !important;\n\n  &.removeCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.selectWrapper {\n  width: 100%;\n}\n\n.phoneFields {\n  display: flex;\n\n  .countryCode {\n    margin-right: 6px;\n  }\n}\n\n.buttons {\n  border-top: 1px solid #dddee0;\n  padding-top: 32px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cancel {\n  color: #6d717a;\n  margin-right: 12px;\n}\n\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n}\n\n.loyalityTabs {\n  margin-top: 16px;\n\n  .tab {\n    flex: 1;\n    max-width: 100% !important;\n  }\n}\n\n.addProgram {\n  display: flex;\n  align-items: center;\n  color: #1e8aff !important;\n  font-size: 13px;\n  padding: 18px 0 18px 24px;\n  border-bottom: 1px solid #c6c8cc;\n  cursor: pointer;\n  &:hover {\n    color: #f6f6f7;\n  }\n  width: 100%;\n  font-weight: 500;\n}\n\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.close {\n  cursor: pointer;\n\n  .icon {\n    color: rgba(0, 0, 0, 0.23);\n  }\n}\n\n.paymentInfo {\n  text-align: left;\n  padding: 32px;\n  margin-bottom: 32px;\n\n  .header {\n    display: flex;\n    padding: 0 0 24px;\n\n    .avatar {\n      margin-right: 24px;\n    }\n\n    .title {\n      font-weight: 500;\n      font-size: 17px;\n      line-height: 20px;\n      color: #1b2432;\n      letter-spacing: 0;\n\n      span {\n        font-size: 13px;\n        color: #6d717a;\n        line-height: 15px;\n        font-weight: 400;\n      }\n    }\n  }\n\n  .infoHeader {\n    display: flex;\n\n    .avatar {\n      margin-right: 24px;\n      margin-top: 3px;\n    }\n\n    .title {\n      font-weight: 500;\n      font-size: 17px;\n      line-height: 20px;\n      color: #1b2432;\n      letter-spacing: 0;\n      flex: 1;\n      display: flex;\n      align-items: flex-end;\n\n      svg {\n        margin-left: 32px;\n      }\n\n      span {\n        font-size: 13px;\n        color: #6d717a;\n        line-height: 15px;\n        font-weight: 400;\n      }\n    }\n\n    .button {\n      color: #318afb;\n      border: 1px solid #318afb;\n      max-width: 74px;\n      min-width: 74px;\n      height: 32px;\n    }\n  }\n\n  .tabs,\n  .tab {\n    text-transform: initial !important;\n  }\n\n  .tabs {\n    border-bottom: 1px solid #c6c8cc;\n  }\n\n  .inputContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding: 16px 0 32px 0;\n    border-bottom: 1px solid #c6c8cc;\n  }\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 8px 0 0;\n  }\n\n  .optional {\n    font-size: 11px;\n    color: #6d717a;\n  }\n\n  .actions {\n    padding: 32px 0 0;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .button {\n    text-transform: initial;\n    min-width: 100px;\n    margin-left: 10px;\n\n    &.buttonCancel {\n      color: #6d717a;\n\n      &:hover,\n      &:focus {\n        background: transparent;\n      }\n    }\n  }\n}\n.loaderContainer {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.dot {\n  height: 4px;\n  width: 4px;\n  background-color: #6d717a;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 4px;\n  margin-right: 4px;\n  margin-bottom: 2px;\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-BookingDetails-Payment-styles___paper--y04EA`,
	"payment": `components-BookingDetails-Payment-styles___payment--ZXVut`,
	"header": `components-BookingDetails-Payment-styles___header--A_dZx`,
	"inputContainer": `components-BookingDetails-Payment-styles___inputContainer--usGEL`,
	"inputWrapper": `components-BookingDetails-Payment-styles___inputWrapper--LVCol`,
	"actions": `components-BookingDetails-Payment-styles___actions--SE5sb`,
	"button": `components-BookingDetails-Payment-styles___button--nJm_l`,
	"muiTab": `components-BookingDetails-Payment-styles___MuiTab--tTF5t`,
	"selected": `components-BookingDetails-Payment-styles___selected--iRJuH`,
	"passportInfo": `components-BookingDetails-Payment-styles___passportInfo--U4Q1V`,
	"tabs": `components-BookingDetails-Payment-styles___tabs--SxUEo`,
	"tab": `components-BookingDetails-Payment-styles___tab--xVOcd`,
	"loyalityTabs": `components-BookingDetails-Payment-styles___loyalityTabs--TTli1`,
	"dropdown": `components-BookingDetails-Payment-styles___dropdown--_0avS`,
	"root": `components-BookingDetails-Payment-styles___root--QKjy6`,
	"menuItem": `components-BookingDetails-Payment-styles___menuItem--ZupkK`,
	"listItem": `components-BookingDetails-Payment-styles___listItem--mjMmF`,
	"location": `components-BookingDetails-Payment-styles___location--uk86M`,
	"inputInVisible": `components-BookingDetails-Payment-styles___inputInVisible--OkmmX`,
	"inputWrapperDepartment": `components-BookingDetails-Payment-styles___inputWrapper_department--ld4D5`,
	"table": `components-BookingDetails-Payment-styles___table--nLDAN`,
	"tableHead": `components-BookingDetails-Payment-styles___tableHead--drqlB`,
	"tableRow": `components-BookingDetails-Payment-styles___tableRow--QJE4J`,
	"tableCell": `components-BookingDetails-Payment-styles___tableCell--RCsrP`,
	"addNewTableRow": `components-BookingDetails-Payment-styles___addNewTableRow--qQC__`,
	"removeCell": `components-BookingDetails-Payment-styles___removeCell--nGP08`,
	"inputTableCell": `components-BookingDetails-Payment-styles___inputTableCell--SAltp`,
	"buttonTableCell": `components-BookingDetails-Payment-styles___buttonTableCell--VMpux`,
	"emptyData": `components-BookingDetails-Payment-styles___emptyData--mFr5r`,
	"selectWrapper": `components-BookingDetails-Payment-styles___selectWrapper--enCgC`,
	"phoneFields": `components-BookingDetails-Payment-styles___phoneFields--DyCFZ`,
	"countryCode": `components-BookingDetails-Payment-styles___countryCode--mPmia`,
	"buttons": `components-BookingDetails-Payment-styles___buttons--RAIEx`,
	"cancel": `components-BookingDetails-Payment-styles___cancel--in4DH`,
	"addProgram": `components-BookingDetails-Payment-styles___addProgram--N2jxW`,
	"addIcon": `components-BookingDetails-Payment-styles___addIcon--FDipl`,
	"close": `components-BookingDetails-Payment-styles___close--dEJH5`,
	"icon": `components-BookingDetails-Payment-styles___icon--Jn7hu`,
	"paymentInfo": `components-BookingDetails-Payment-styles___paymentInfo--eWxPG`,
	"avatar": `components-BookingDetails-Payment-styles___avatar--t0Kyf`,
	"title": `components-BookingDetails-Payment-styles___title--Oo7og`,
	"infoHeader": `components-BookingDetails-Payment-styles___infoHeader--sRrX1`,
	"optional": `components-BookingDetails-Payment-styles___optional--IG1KE`,
	"buttonCancel": `components-BookingDetails-Payment-styles___buttonCancel--GLUxz`,
	"loaderContainer": `components-BookingDetails-Payment-styles___loaderContainer--sBS9d`,
	"dot": `components-BookingDetails-Payment-styles___dot--kjMbe`
};
module.exports = ___CSS_LOADER_EXPORT___;
